<section class="semi-transparent-card">
  <ng-content> </ng-content>
</section>
